import { Observable } from "rxjs/Rx";
import { GemsHttpService } from "../../shared/services/gems-http.service";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { GemsService } from "client/app/shared/services";
import { catchError, map } from "rxjs/operators";
import { forkJoin, of } from "rxjs";
import { EnumInjectionTokens } from "client/app/shared";
import { IEnvironment } from "client/app/shared/interfaces";

@Injectable({ providedIn: 'root' })
export class BprAuthGuardService {

  constructor(
    private gemsHttp: GemsHttpService,
    private gemsService: GemsService,
    @Inject(EnumInjectionTokens.Environment) private environment: IEnvironment
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return forkJoin({
      umbraco: this.gemsHttp.get(this.environment.umbracoChannelRoleUrl("internal-administration")),
      user: this.gemsService.getUser()
    }).pipe(
      map(({ umbraco, user }) => {
        const data: { pageAlias: string, roles: [string] } = umbraco.body;

        const strippedRoles = data.roles.map(role => {
          const strippedRole = role.replace(/^NEB|_/gi, '');
          return 'has' + strippedRole;
        });

        const adminRoles = strippedRoles.reduce((accum, role) => {
          const found = user.roles.some(x => x === role);
          if (found) accum.push(role);
          return accum;
        }, []);

        var requiredRoles = adminRoles.some(x => {
          return x === 'hasUnderwriting'
            || x === 'hasBprSuperUser'
        })

        if (requiredRoles) return true;
        else {
          window.location.href = this.environment.base.envUrl;
          return false;
        }
      }),
      catchError(err => {
        console.error('handling error', err);
        return of(false);
      })
    );
  }
}
